import React from "react"
import { useContext } from "react"
import GameContext from "../../../Context/GameContext"
import { actions } from "../../shared/constants"
import { Slides } from "../slides/Slides"
import { createHostAction } from "../createHostAction"
import { defaultLabels } from "../../shared/defaultLabels"
import { fallbackContent } from "../../shared/fallbackContent"

export const GlobalIntro = props => {
  const { gameData, onAction } = useContext(GameContext)

  const handleEnd = () => {
    onAction(createHostAction(actions.HOST_START_ROUNDS))
  }

  const content =
    gameData?.game_intro?.host_intro_slides ||
    fallbackContent.game_intro.host_intro_slides

  const previous =
    gameData?.game_defaults?.host_previous_button ||
    defaultLabels?.GAME_DEFAULTS_HOST_PREVIOUS_BUTTON

  const next =
    gameData?.game_defaults?.host_next_button ||
    defaultLabels?.GAME_DEFAULTS_HOST_NEXT_BUTTON

  const end =
    gameData?.game_intro?.host_start_game_button ||
    defaultLabels?.GAME_INTRO_HOST_START_GAME_BUTTON

  const backgroundImage = gameData?.game_intro?.host_background_image || null

  return (
    <Slides
      content={content}
      labels={{
        previous,
        next,
        end,
      }}
      handleEnd={handleEnd}
      backgroundImage={backgroundImage}
    />
  )
}
